import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  raised?: boolean;
}

export function Card({ raised = false, className = '', children, ...rest }: CardProps): JSX.Element {
  return (
    <div
      {...rest}
      className={`rounded-lg border border-bark-300/60 bg-paper-100 p-5 ${raised ? 'shadow-raised' : 'shadow-paper'} ${className}`}
    >
      {children}
    </div>
  );
}
